var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 725.285,
    height: 655.721,
    viewBox: "0 0 725.285 655.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 725.285,
    height: 644.092,
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2944",
    "data-name": "Rectangle 2944",
    width: 389,
    height: 482,
    transform: "translate(-2105.725 -17990.361)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43762",
    "data-name": "Path 43762",
    d: "M477.127,380.345V396.3l23.939,9.119,18.809-1.709,3.419-7.41V377.495Z",
    transform: "translate(-477.127 -377.495)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10.904,
    y1: 8.57,
    x2: -10.881,
    y2: 8.57,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd6c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0ac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2937",
    "data-name": "Rectangle 2937",
    width: 1098.362,
    height: 778.678,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43764",
    "data-name": "Path 43764",
    d: "M466.6,349.241c.569,12.729,4.331,39.783,14.818,46.167,13.11,7.978,29.639,11.4,40.469,0s14.818-42.177,11.4-57c-2.736-11.854-45.788-17.29-66.687-18.809Z",
    transform: "translate(-466.601 -319.602)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.789,
    y1: 3.709,
    x2: -4.778,
    y2: 3.709,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43772",
    "data-name": "Path 43772",
    d: "M461.876,336.371c-2.09.379-5.357,3.191-1.709,11.4,4.559,10.259,5.7,11.4,9.119,11.969,1.657.276,1.306-5.736-.144-11.75-1.418-5.88-3.886-11.76-6.557-11.759a1.888,1.888,0,0,0-.709.141",
    transform: "translate(-458.524 -336.23)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -28.382,
    y1: 14.434,
    x2: -28.32,
    y2: 14.434,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43773",
    "data-name": "Path 43773",
    d: "M523.345,347.989c-1.45,6.014-1.8,12.026-.143,11.75,3.42-.569,4.56-1.709,9.119-11.969,3.648-8.208.38-11.021-1.71-11.4a1.888,1.888,0,0,0-.709-.141c-2.672,0-5.14,5.879-6.558,11.759",
    transform: "translate(-522.101 -336.23)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -23.798,
    y1: 13.736,
    x2: -23.752,
    y2: 13.736,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83801",
    "data-name": "Group 83801",
    transform: "translate(-1068.357 -349.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83784",
    "data-name": "Group 83784",
    transform: "translate(-109.798 -158.205)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83673",
    "data-name": "Group 83673",
    transform: "translate(1178.155 507.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83672",
    "data-name": "Group 83672",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43602",
    "data-name": "Path 43602",
    d: "M417.86,287.532c70.282-24.983,222.4,76.793,236.248-11.743s-98.214-87.65-76.808-174.975-68-146.434-133.471-54.551S298.4-10.434,145.253,61.336C1.057,128.912,24.532,401.429,244.164,398.684c92.776-1.159,118.025-91.362,173.7-111.153",
    transform: "translate(33.628 0)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43603",
    "data-name": "Path 43603",
    d: "M267.493,238.663c13.641-20.119,38.029-50.6,75.887-45.484S424.467,240,505.894,238.663,609.983,353.772,554.58,413.491,374.1,316.233,277.567,359.045,248.824,266.2,267.493,238.663",
    transform: "translate(140.292 119.071)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43604",
    "data-name": "Path 43604",
    d: "M406.367,383.675a60.836,60.836,0,1,1-60.836-60.836,60.837,60.837,0,0,1,60.836,60.836",
    transform: "translate(175.999 199.58)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43605",
    "data-name": "Path 43605",
    d: "M69.369,106.9A34.685,34.685,0,1,1,34.685,72.22,34.684,34.684,0,0,1,69.369,106.9",
    transform: "translate(0 44.647)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43606",
    "data-name": "Path 43606",
    d: "M181.289,361.381a82.8,82.8,0,1,1-82.8-82.8,82.8,82.8,0,0,1,82.8,82.8",
    transform: "translate(9.699 172.22)",
    fill: "#e4e4e4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83783",
    "data-name": "Group 83783",
    transform: "translate(-116.317 -38.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43645",
    "data-name": "Path 43645",
    d: "M550.576,380.843H810.851a24.879,24.879,0,0,1,0,49.758H550.576a24.879,24.879,0,0,1,0-49.758",
    transform: "translate(944.407 363.6)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43646",
    "data-name": "Path 43646",
    d: "M551.492,393.325h114.5a12.4,12.4,0,0,1,0,24.8h-114.5a12.4,12.4,0,1,1,0-24.8",
    transform: "translate(944.407 363.6)",
    fill: "#cfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43647",
    "data-name": "Path 43647",
    d: "M796.5,336.825a68.9,68.9,0,1,1-68.9,68.9,68.9,68.9,0,0,1,68.9-68.9",
    transform: "translate(944.407 363.6)",
    fill: "#3c9bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43648",
    "data-name": "Path 43648",
    d: "M818.758,399.1a22.637,22.637,0,0,0-42.391-6.107,18.33,18.33,0,0,0,1.967,36.534h39.359a15.236,15.236,0,0,0,1.065-30.427m-16.21,9.053v12.214h-12.1V408.149h-9.082L796.5,392.883,811.63,408.15h-9.082Z",
    transform: "translate(944.407 363.6)",
    fill: "#cfe9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43649",
    "data-name": "Path 43649",
    d: "M670.188,380.844h-2.871V372.4h2.871Zm0-13.133h-2.871v-9.381h2.871Zm0-14.073h-2.871v-9.381h2.871Zm0-14.072h-2.871v-9.381h2.871Zm0-14.073h-2.871v-9.381h2.871Zm0-14.072h-2.871v-9.381h2.871Zm0-14.073h-2.871v-9.381h2.871Zm0-14.072h-2.871V273.9h2.871Zm0-14.072h-2.871v-9.381h2.871Zm0-14.073h-2.871v-9.381h2.871Zm0-14.072h-2.871v-9.381h2.871Zm0-14.073h-2.871v-9.381h2.871Zm0-14.072h-2.871v-9.381h2.871Zm0-14.072h-2.871v-9.381h2.871Z",
    transform: "translate(944.407 363.6)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43650",
    "data-name": "Path 43650",
    d: "M676.886,190.421a8.612,8.612,0,1,1-8.612-8.612,8.613,8.613,0,0,1,8.612,8.612",
    transform: "translate(944.407 363.6)",
    fill: "#194079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43653",
    "data-name": "Path 43653",
    d: "M746.738,127.4a11.072,11.072,0,0,0-11.073-11.071H649.3V127.4Z",
    transform: "translate(944.407 363.6)",
    fill: "#3c9bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43654",
    "data-name": "Path 43654",
    d: "M639.335,104.146H601.689c-7.75,0-9.964,3.321-9.964,9.965v9.861A3.427,3.427,0,0,1,588.3,127.4a12.223,12.223,0,0,0-12.076,14.116L590.1,230.008a12.225,12.225,0,0,0,12.076,10.327h134.1a12.224,12.224,0,0,0,12.075-10.327l13.881-88.494A12.222,12.222,0,0,0,750.163,127.4H668.878a12.224,12.224,0,0,1-9.946-5.118l-7.783-10.9c-.283-.4-.54-.808-.814-1.21a13.489,13.489,0,0,0-11-6.027",
    transform: "translate(944.407 363.6)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43655",
    "data-name": "Path 43655",
    d: "M696.6,177.6a27.363,27.363,0,0,0-50.944-7.2,21.6,21.6,0,0,0,2.365,43.089h47.287A17.96,17.96,0,0,0,696.6,177.6",
    transform: "translate(944.407 363.6)",
    fill: "#cfe9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_215",
    "data-name": "Mask Group 215",
    transform: "translate(3216.871 18513.096)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83798",
    "data-name": "Group 83798",
    transform: "translate(-2505.338 -18319.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43759",
    "data-name": "Path 43759",
    d: "M405.494,436.343h0a2.28,2.28,0,0,1,2.28,2.28v27.358a2.28,2.28,0,1,1-4.56,0V438.623a2.28,2.28,0,0,1,2.28-2.28",
    transform: "translate(77.128 83.465)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43760",
    "data-name": "Path 43760",
    d: "M394.969,501.412h0a2.28,2.28,0,0,1,2.28,2.28V531.05a2.28,2.28,0,0,1-4.56,0V503.692a2.28,2.28,0,0,1,2.28-2.28",
    transform: "translate(75.114 95.911)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43761",
    "data-name": "Path 43761",
    d: "M405.494,501.412h0a2.28,2.28,0,0,1,2.28,2.28V531.05a2.28,2.28,0,0,1-4.56,0V503.692a2.28,2.28,0,0,1,2.28-2.28",
    transform: "translate(77.128 95.911)",
    fill: "#ff5656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2935",
    "data-name": "Rectangle 2935",
    width: 1098.362,
    height: 778.678,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83786",
    "data-name": "Group 83786",
    transform: "translate(568.393 449.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83785",
    "data-name": "Group 83785",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2936",
    "data-name": "Rectangle 2936",
    width: 51.868,
    height: 39.039,
    transform: "translate(-7.056 1.914) rotate(-15.175)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83788",
    "data-name": "Group 83788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83787",
    "data-name": "Group 83787",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43763",
    "data-name": "Path 43763",
    d: "M500.5,396.506c-12.543,0-21.279-11.019-23.368-14.249l46.167-2.85c-2.849,6.839-8.55,17.1-22.8,17.1",
    transform: "translate(91.266 72.574)",
    fill: "#1d164d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83790",
    "data-name": "Group 83790",
    transform: "translate(555.854 380.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83789",
    "data-name": "Group 83789",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2938",
    "data-name": "Rectangle 2938",
    width: 111.724,
    height: 110.429,
    transform: "matrix(0.668, -0.744, 0.744, 0.668, -43.353, 48.265)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83792",
    "data-name": "Group 83792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83791",
    "data-name": "Group 83791",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43765",
    "data-name": "Path 43765",
    d: "M484.548,346.469c1.075.048,1.848,2.265,1.726,4.95s-1.089,4.822-2.162,4.775-1.848-2.265-1.727-4.95,1.089-4.822,2.163-4.775",
    transform: "translate(92.269 66.273)",
    fill: "#151c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43766",
    "data-name": "Path 43766",
    d: "M507.966,346.469c1.075.048,1.848,2.265,1.726,4.95s-1.089,4.822-2.162,4.775-1.848-2.265-1.727-4.95,1.089-4.822,2.163-4.775",
    transform: "translate(96.749 66.273)",
    fill: "#151c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43767",
    "data-name": "Path 43767",
    d: "M483.69,340.215a6.78,6.78,0,0,0-3.763,2.109.608.608,0,0,1-.9-.821,7.992,7.992,0,0,1,4.483-2.491c2-.3,4.215.391,6.174,2.97a.608.608,0,1,1-.969.736c-1.719-2.263-3.511-2.728-5.027-2.5",
    transform: "translate(91.599 64.835)",
    fill: "#7c4030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43768",
    "data-name": "Path 43768",
    d: "M508.857,340.215a6.78,6.78,0,0,0-3.763,2.109.608.608,0,1,1-.9-.821,7.991,7.991,0,0,1,4.483-2.491c2-.3,4.215.391,6.174,2.97a.608.608,0,1,1-.967.736c-1.72-2.263-3.512-2.728-5.028-2.5",
    transform: "translate(96.413 64.835)",
    fill: "#7c4030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43769",
    "data-name": "Path 43769",
    d: "M496.8,370.11a3.477,3.477,0,0,1-1.3-.247,2.7,2.7,0,0,1-1.68-3.24c.3-1.294.573-3.58.888-6.227.372-3.112.792-6.638,1.389-9.713a.57.57,0,1,1,1.12.218c-.59,3.033-1.008,6.538-1.376,9.629-.32,2.68-.6,5-.909,6.35a1.567,1.567,0,0,0,.995,1.926,2.607,2.607,0,0,0,3.181-1.208.57.57,0,0,1,.978.585,3.8,3.8,0,0,1-3.284,1.926",
    transform: "translate(94.443 66.992)",
    fill: "#f4ac94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43770",
    "data-name": "Path 43770",
    d: "M504.908,371.151a.608.608,0,0,1,.236.828,7.814,7.814,0,0,1-5.089,4.03,8.107,8.107,0,0,1-4.586-.262.608.608,0,0,1,.435-1.137,6.876,6.876,0,0,0,3.87.214,6.593,6.593,0,0,0,4.306-3.439.608.608,0,0,1,.828-.235",
    transform: "translate(94.7 70.98)",
    fill: "#d74848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43771",
    "data-name": "Path 43771",
    d: "M470.835,313.933c-13.223-3.648-12.349,19.569-10.259,30.778,3.191,0,6.46,8.93,7.41,12.539,2.28-4.56,2.85-16.529,3.99-23.939s8.55-7.41,24.508,3.99S531.821,343,534.1,343c1.824,0,1.14,18.239,1.14,23.368,0-10.487,5.7-21.468,7.979-21.659v-5.7c13.109-9.119,4.559-26.219,5.13-20.519.456,4.559-2.66,9.5-5.13,10.829-3.42-23.368-13.209-33.98-38.188-36.478-22.8-2.279-29.638,14.06-34.2,21.089",
    transform: "translate(87.868 55.975)",
    fill: "#4e3644"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83794",
    "data-name": "Group 83794",
    transform: "translate(546.231 400.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83793",
    "data-name": "Group 83793",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2940",
    "data-name": "Rectangle 2940",
    width: 19.093,
    height: 26.283,
    transform: "translate(-6.883 1.045) rotate(-12.109)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83796",
    "data-name": "Group 83796",
    transform: "translate(621.97 400.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83795",
    "data-name": "Group 83795",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2941",
    "data-name": "Rectangle 2941",
    width: 25.872,
    height: 27.667,
    transform: "matrix(0.796, -0.605, 0.605, 0.796, -12.012, 8.696)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83797",
    "data-name": "Group 83797",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43774",
    "data-name": "Path 43774",
    d: "M412.536,574.939V566.96H605.755v7.979L511.14,614.267Z",
    transform: "translate(78.911 108.449)",
    fill: "#28284a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43775",
    "data-name": "Path 43775",
    d: "M427.326,631.121c9.266-3.791,15.2.191,16.529,2.28,9.69-.76,24.166-1.368,4.56,15.958-24.509,21.659-54.147,1.711-66.687-5.7s2.85-18.809,8.55-18.809,24.508,11.4,37.048,6.27",
    transform: "translate(72.101 119.523)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43776",
    "data-name": "Path 43776",
    d: "M432.5,641.445c6.384-2.28,138.5-56.236,200.627-82.645,26.219-11.14,48.447,12.539,48.447,38.758s-50.726,33.058-91.764,39.327S423.385,676.213,432.5,663.674s-7.979-19.379,0-22.228",
    transform: "translate(82.312 106.349)",
    fill: "#37365a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43777",
    "data-name": "Path 43777",
    d: "M578.387,658.388c-15.047,2.736-24.508-3.8-27.358-7.41-1.9-10.45-3.306-29.98,6.269-24.508,11.97,6.839,32.489,2.85,41.608,0s19.949-.569,22.229,9.119-23.939,19.379-42.748,22.8",
    transform: "translate(105.139 119.614)",
    fill: "#74b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43778",
    "data-name": "Path 43778",
    d: "M347.582,584.338c2.736-16.415,20.519-25.079,29.068-27.358,8.207-1.824,20.139,2.659,25.078,5.13,39.9,16.718,125.963,51.98,151.041,59.276,31.349,9.119,53.007,18.239,43.887,18.809s.571,23.368-6.839,23.939-200.058-33.058-218.3-39.328-27.359-19.949-23.939-40.468",
    transform: "translate(66.351 106.459)",
    fill: "#4a4975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43779",
    "data-name": "Path 43779",
    d: "M410.3,431.876c6.839-10.487,46.927-21.849,66.116-26.219a53.292,53.292,0,0,1,11.4-1.139c6.839,0,3.419-3.991,3.419-9.69s3.42-3.99,9.12,0,23.368,2.85,29.638,1.709,12.539-7.979,10.829-1.709-1.709,9.119,11.4,9.69,63.267,20.519,71.246,37.617S638.284,547.579,636,560.118c-1.824,10.031-16.338,24.7-23.368,30.778-64.407.379-195.043-.342-202.338-6.27-9.119-7.41-18.239-15.389-18.809-43.888s10.259-95.754,18.809-108.863",
    transform: "translate(74.881 74.823)",
    fill: "#ff586c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43780",
    "data-name": "Path 43780",
    d: "M414.3,466.007H602.385a7.98,7.98,0,0,1,7.979,7.979V585.7a7.98,7.98,0,0,1-7.979,7.979H414.3a7.98,7.98,0,0,1-7.979-7.979V473.986a7.98,7.98,0,0,1,7.979-7.979",
    transform: "translate(77.721 89.139)",
    fill: "#e2f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43781",
    "data-name": "Path 43781",
    d: "M494.084,510.981a10.259,10.259,0,1,1-10.259,10.259,10.26,10.26,0,0,1,10.259-10.259",
    transform: "translate(92.547 97.742)",
    fill: "#194079"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2943",
    "data-name": "Rectangle 2943",
    width: 1098.362,
    height: 778.678,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.dac8aae581d22948dc9345db24439fba.svg";
export { ForwardRef as ReactComponent };